module.exports = __webpack_public_path__ + "img/arrow-right.7bcf05f9.png";